import React from 'react';

const NaturalPrice = props => {
  return (
    <React.Fragment>
      <div className="NaturalPrice">
        <div className="NaturalPriceDetail">
          通常料金 /月 {props.price} 円
        </div>
        <div className="NaturalPriceValueWithTax">
          (税込 {props.priceWithTax}円)
        </div>
      </div>
    </React.Fragment>
  );
};

export default NaturalPrice;
